import _get from 'lodash/get'
import _isBoolean from 'lodash/isBoolean'
import { renew } from 'services/auth'
import { getEmailAvailability } from 'services/user'
import { setAuthPersistentData } from 'services/auth/actions'
import {
  approveRemoteLoginCode,
  consumeRemoteLoginCode,
  requestMagicLink,
  approvePrivateLoginCode,
} from './index'

export const SET_REMOTE_LOGIN_CODE = 'SET_REMOTE_LOGIN_CODE'
export const SET_REMOTE_LOGIN_CODE_PROCESSING = 'SET_REMOTE_LOGIN_CODE_PROCESSING'
export const SET_REMOTE_LOGIN_CODE_DATA = 'SET_REMOTE_LOGIN_CODE_DATA'

export function getRemoteLoginCodeApproval ({ auth, remoteLoginCode }) {
  return async function getRemoteLoginCodeApprovalThunk (dispatch) {
    dispatch(setRemoteLoginCodeProcessing(true))
    const data = await approveRemoteLoginCode({ auth, remoteLoginCode })
    dispatch(setRemoteLoginCodeData(data))
    return data
  }
}

export function setRemoteLoginCode (value) {
  return {
    type: SET_REMOTE_LOGIN_CODE,
    payload: value,
  }
}

export function setRemoteLoginCodeProcessing (value) {
  return {
    type: SET_REMOTE_LOGIN_CODE_PROCESSING,
    payload: value,
  }
}

export function setRemoteLoginCodeData (data, processing = false) {
  return {
    type: SET_REMOTE_LOGIN_CODE_DATA,
    payload: { data, processing },
  }
}

export function doConsumeRemoteLoginCode ({ remoteLoginCode }) {
  return async function doConsumeRemoteLoginCodeThunk (dispatch) {
    try {
      const { jwt } = await consumeRemoteLoginCode({ remoteLoginCode })
      // Renew auth data with a jwt obtained from remote login code response
      const data = await renew({ auth: { jwt }, logoutAllDevices: false })
      const success = _get(data, 'auth.success', false)
      if (success) {
        dispatch(setAuthPersistentData(data.auth))
      }
      return { success: !!success }
    } catch (e) {
      return { success: false }
    }
  }
}

export function doRequestMagicLink ({ email, language }) {
  return async function doRequestMagicLinkThunk (dispatch) {
    try {
      dispatch(setRemoteLoginCodeProcessing(true))
      const { available } = await getEmailAvailability({ email })
      if (!_isBoolean(available) || available === true) {
        throw new Error('emailNotExists')
      }
      const { remoteLoginCode, expiresAt } = await requestMagicLink({ email, language })
      return { success: true, remoteLoginCode, expiresAt }
    } catch (e) {
      return { success: false, message: e.message }
    } finally {
      dispatch(setRemoteLoginCodeProcessing(false))
    }
  }
}

export function doApprovePrivateLoginCode ({ privateCode }) {
  return async function doApprovePrivateLoginCodeThunk (dispatch) {
    try {
      dispatch(setRemoteLoginCodeProcessing(true))
      const { remoteLoginCode } = await approvePrivateLoginCode({ privateCode })
      if (remoteLoginCode) {
        // const { jwt } = await consumeRemoteLoginCode({ remoteLoginCode })
        // const data = await renew({ auth: { jwt }, logoutAllDevices: false })
        // const success = _get(data, 'auth.success', false)
        // if (success) {
        //  dispatch(setAuthPersistentData(data.auth))
        // }
        return { success: true }
      }
      return { success: false }
    } catch (e) {
      return { success: false, message: e.message }
    } finally {
      dispatch(setRemoteLoginCodeProcessing(false))
    }
  }
}
